import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CreateRoom from "./pages/CreateRoom";
import Watch from "./pages/Watch";
import Profile from "./pages/Profile";
import Messages from "./pages/Messages";
import Admin from "./pages/Admin";
import Broadcaster from "./pages/Broadcaster";
import Live from "./pages/Live";

function Loader() {
  return <div className="min-h-screen bg-[#141414] flex items-center justify-center text-gray-500">Yükleniyor...</div>;
}

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/create" element={<Protected><CreateRoom /></Protected>} />
            <Route path="/watch/:slug" element={<Protected><Watch /></Protected>} />
            <Route path="/u/:username" element={<Profile />} />
            <Route path="/messages" element={<Protected><Messages /></Protected>} />
            <Route path="/messages/:username" element={<Protected><Messages /></Protected>} />
            <Route path="/yayinci" element={<Protected><Broadcaster /></Protected>} />
            <Route path="/live/:id" element={<Protected><Live /></Protected>} />
            <Route path="/adc" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" richColors />
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
